import Vue from "vue";
import VUploadImage from '@/components/v-upload-image'
import uImage from "../components/u-image";
import uVideo from "../components/u-video";

const custom = {
  install: function(Vue) {
    Vue.component("uImage", uImage);
    Vue.component("uVideo", uVideo);
    Vue.component("VUploadImage", VUploadImage);
  }
};

Vue.use(custom);
